import { render, staticRenderFns } from "./calculationFactor.vue?vue&type=template&id=5b0512a6"
import script from "./calculationFactor.vue?vue&type=script&lang=js"
export * from "./calculationFactor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports